export default {
  /**
   * 英文环境是否显示导航
   * @returns {boolean}
   */
  showTitle: function () {
    let lang = window.localStorage.getItem('tw_i18n_local') === 'zh_CN' ? 'zh_CN' : 'en_US'
    if (lang === 'en-US') {
      return false
    }
    return true
  },
  /**
   * 所有环境是否显示导航
   * @returns {boolean}
   */
  show: function () {
    return false
  }
}



// WEBPACK FOOTER //
// ./src/utils/webBase.js